<template>
  <the-section>
    <template #sub>
      <p class="text-body-02 break-all mb-4 text-sm">
        {{ full_name }}
      </p>
    </template>
    <el-row type="flex" flex-wrap="wrap" justify="space-between" align="middle">
      <p class="text-body-01 text-sm break-all">
        {{ rank_name }}
      </p>
      <router-link :to="rankDetailUrl" class="memberRank__button flex-end text-base rounded">
        {{ $t('ec-line009.memberRank.detailButton') }}
      </router-link>
    </el-row>
  </the-section>
</template>

<script>
import TheSection from '@/components/my-page-partials/TheSection.vue'

export default {
  components: { TheSection },
  props: {
    data: { type: Object, default: () => {} },
  },
  data() {
    return {
      rankDetailUrl: this.$routePage.EC_LINE038,
    }
  },
  computed: {
    full_name() {
      return this.Utils.helper.fullName(this.data.name01, this.data.name02) + this.$t('ec-line009.memberRank.nameSub')
    },
    rank_name() {
      return this.data.rank_name ? this.data.rank_name : this.$t('common.hyphenSeparator')
    },
  },
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/components/ec-line009/rank-member-information.scss';
</style>
